import type { ReactNode } from "react";

import { AppText } from "./AppText";
import { Stack } from "./Stack";

/** Card/section intro: title + optional supporting line. */
export function SectionHeader({
  title,
  description,
}: {
  title: string;
  description?: ReactNode;
}) {
  return (
    <Stack gap="xs">
      <AppText size="lg" weight="semibold">
        {title}
      </AppText>
      {description ? (
        typeof description === "string" ? (
          <AppText size="sm" tone="muted">
            {description}
          </AppText>
        ) : (
          description
        )
      ) : null}
    </Stack>
  );
}
